import Portal from "@Portals/components/Portal";
import datasetParser from "@Dataset/datasetParser";
import GbtVehicles from "@Features/getByTransfer/components/GbtVehicles";
import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";
import useGetGbtVehicles from "@Features/getByTransfer/hooks/useGetGbtVehicles";

type VehiclesSnippetDataType = { vehicles: Record<number, GbtVehicleSnippetType | TransfersVehicleType> } | undefined

function GbtVehiclesPortal() {
    const {vehicles}: VehiclesSnippetDataType = datasetParser({
        id: "gbt-vehicle-snippets-portal",
    }) || {}

    const {getGbtVehicles} = useGetGbtVehicles()

    if (!vehicles) {
        return null
    }

    return (
        <Portal
            id="gbt-vehicle-snippets-portal"
        >
            <GbtVehicles
                vehicles={getGbtVehicles(Object.entries(vehicles).map(([index, vehicle]) => (
                    vehicle
                )))}
            />
        </Portal>
    )
}

export default GbtVehiclesPortal